exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {margin: 0; padding: 0}\nhtml {min-height:100%;position:relative}\nbody, #app {min-height:100vh}\nbody {font-size:0.875rem; font-family:inherit}/* 14px normal text*/\nh1{font-size:1rem!important; font-weight:inherit!important; letter-spacing: -0.01rem!important} /* 20 px normal */\nh2{font-size:1.25rem!important; font-weight:600!important} /* 20 px normal*/\nh3{font-size:1rem!important; font-weight:400!important} /* 16 px normal */\nh4{font-size:0.875rem!important; font-weight:600!important} /* 14 px bold  */\nh5{font-size:0.875rem!important; font-weight:400!important} /* 14 px normal */\nh6{font-size:0.625rem!important; font-weight:400!important; color:#9B9B9B} /* 10 px normal */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??postcss!./src/index.css
// module id = 1641
// module chunks = 0